import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { RunnerDecisionsQuery, RunnerDecisionsQueryVariables } from './__generated__/RunnerDecisionsQuery';

export const RUNNER_DECISIONS_QUERY = gql`
  query RunnerDecisionsQuery(
    $campaignId: ID!
    $date: String!
    $filter: RunnerDecisionsFilterInput
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    runnerDecisions(
      campaignId: $campaignId
      date: $date
      filter: $filter
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      edges {
        node {
          actionType
          block
          info
          sampleStartTime
          adSet {
            id
            facebookAdSetId
          }
          article {
            id
            title
          }
          campaign {
            id
          }
          facebookAd {
            id
            facebookAdId
          }
          keyweeFacebookCampaign {
            id
            facebookCampaignId
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
`;

export const useRunnerDecisionsLazyQuery = () => {
  return useLazyQuery<RunnerDecisionsQuery, RunnerDecisionsQueryVariables>(RUNNER_DECISIONS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};
